/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/naming-convention */
import PropTypes from 'prop-types';
import React, { Component, PropsWithChildren } from 'react';
import { constants } from 'smooth-dnd';

const { wrapperClass } = constants;

export type DraggableProps = PropsWithChildren<{
    render?: () => React.ReactElement;
    className?: string;
}>;

export class DraggableItem extends Component<DraggableProps> {
    public static propsTypes = {
        render: PropTypes.func,
        className: PropTypes.string,
    };

    public override render() {
        if (this.props.render) {
            return React.cloneElement(this.props.render(), { className: wrapperClass } as any);
        }

        const clsName = `${this.props.className ? `${this.props.className} ` : ''}`;
        return (
            <div {...this.props} className={`${clsName}${wrapperClass}`}>
                {this.props.children}
            </div>
        );
    }
}
